<main>
  <div class="as-row as-justify-sb as-align-center as-header">
    <mat-icon
      mat-dialog-close
      [routerLink]="['']"
      class="as-logo as-pointer"
      svgIcon="ic-logo-alsuper.com"
    ></mat-icon>
    <mat-icon
      mat-dialog-close
      class="as-pointer as-icon-grey"
      svgIcon="ic-close-green"
    ></mat-icon>
  </div>
  <div class="as-column as-menu">
    <div
      class="as-tab-wrapper"
      *ngFor="let tab of menu; let i = index; let last = last"
    >
      <ng-container *ngIf="selectedTabIndex === null || selectedTabIndex === i">
        <div
          class="as-tab as-row as-align-center {{
            tab.class ? tab.class : ''
          }} {{ selectedTabIndex === i && !tab.class ? 'as-bg-green' : '' }}"
          [ngClass]="
            selectedTabIndex === i ? 'as-gap-10 as-shade' : 'as-justify-sb'
          "
          (click)="tab.arrow ? selectTab(i) : redirect(tab.redirect)"
        >
          <div
            class="as-icon-wrapper"
            *ngIf="tab.arrow && selectedTabIndex === i"
          >
            <mat-icon
              class="as-arrow"
              [ngClass]="
                tab.name !== 'Club Alsuper' ? 'as-icon-green' : 'as-icon-white'
              "
              svgIcon="ic-arrow-left"
            ></mat-icon>
          </div>
          <ng-container [ngSwitch]="tab.name">
            <div
              class="as-row as-align-center as-gap-10"
              *ngSwitchCase="'Mi Cuenta'"
            >
              <ng-container *ngIf="data.user; else noLogin">
                <div class="as-green circle">
                  <p class="as-font-white as-font as-font-normal as-font-14">
                    {{ data.user.name | slice : 0 : 1 | uppercase }}
                  </p>
                </div>
                <div class="as-font as-font-black-gray">
                  <p class="as-font-normal as-font-14">
                    Hola, {{ data.user.name }}
                  </p>
                  <p class="as-font-bold as-font-12">{{ tab.name }}</p>
                </div>
              </ng-container>
              <ng-template #noLogin>
                <div class="as-column as-gap-5">
                  <p
                    class="as-font as-font-14 as-font-normal as-pointer as-font-black-gray"
                  >
                    Bienvenido!
                  </p>
                  <p
                    class="as-font as-font-12 as-font-bold as-pointer as-font-black-gray"
                  >
                    {{ 'AUTH.signin' | translate }}
                  </p>
                </div>
              </ng-template>
            </div>
            <div
              class="as-row as-align-center as-gap-10"
              *ngSwitchCase="'Club Alsuper'"
            >
              <mat-icon
                class="as-club-alsuper-logo"
                svgIcon="ic-club-alsuper-logo"
              ></mat-icon>
              <div
                *ngIf="card_owner; else noCard"
                class="as-font as-font-white as-font-bold"
                (click)="openClubAlsuper('redeem')"
              >
                <p class="as-font-12">{{ clubAmmount }} puntos disponibles</p>
                <p class="as-font-14">{{ card_owner }}</p>
              </div>
              <ng-template #noCard>
                <div
                  class="as-font as-font-white as-font-bold"
                  (click)="openClubAlsuper('card')"
                >
                  <p class="as-font-12">Agregar tarjeta Club Alsuper</p>
                  <p class="as-font-14">Obtén hasta un 20% de descuento</p>
                </div>
              </ng-template>
            </div>
            <div class="as-row as-align-center as-gap-10" *ngSwitchDefault>
              <mat-icon
                class="as-arrow as-icon-grey"
                [svgIcon]="tab.icon"
              ></mat-icon>
              <p class="as-font as-font-14 as-font-black-gray as-font-normal">
                {{ tab.name }}
              </p>
            </div>
          </ng-container>
          <div
            class="as-icon-wrapper"
            *ngIf="tab.arrow && selectedTabIndex !== i"
          >
            <mat-icon
              class="as-arrow as-icon-grey"
              [ngClass]="
                tab.name !== 'Club Alsuper' ? 'as-icon-grey' : 'as-icon-white'
              "
              svgIcon="ic-arrow-right-grey"
            ></mat-icon>
          </div>
        </div>
        <div class="as-divider-wrapper" *ngIf="selectedTabIndex !== i">
          <mat-divider></mat-divider>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngIf="selectedTabIndex !== null">
    <ng-container [ngSwitch]="selectedTabIndex">
      <div class="as-accounts" *ngSwitchCase="0">
        <div
          class="as-row as-justify-sb as-align-center as-account-menu"
          *ngFor="let menu of accountMenu"
        >
          <div
            mat-dialog-close
            [routerLink]="menu.route"
            class="as-row as-align-center as-gap-10"
          >
            <mat-icon class="as-icon-grey" [svgIcon]="menu.icon"></mat-icon>
            <p class="as-font as-font-14 as-font-normal as-font-black-gray">
              {{ menu.label | translate }}
            </p>
          </div>
          <mat-icon
            class="as-arrow as-icon-grey"
            svgIcon="ic-arrow-right-grey"
          ></mat-icon>
        </div>
        <div class="as-close-sesion">
          <mat-divider></mat-divider>
          <div (click)="closeSesion()" class="as-row as-align-center as-gap-10">
            <mat-icon class="as-icon-grey" svgIcon="ic-close-sesion"></mat-icon>
            <p class="as-font as-font-14 as-font-normal as-font-black-gray">
              Cerrar sesión
            </p>
          </div>
        </div>
      </div>
      <div class="as-departments" *ngSwitchCase="1">
        <!-- <div class="as-dept as-row as-align-center">
          <a [routerLink]="['/departamento']">
            <mat-label class="as-font-black-gray as-font as-font-14">
              {{ 'FILTER.allDepartments' | translate }}
            </mat-label>
          </a>
        </div> -->
        <div *ngFor="let department of departments">
          <a mat-dialog-close [routerLink]="[department.department_url]">
            <div class="as-row as-align-center as-gap-10 as-pointer as-dept">
              <img
                width="19px"
                height="19px"
                [src]="department.icon_url"
                alt="Department icon"
              />
              <mat-label class="as-font-black-gray as-font as-font-14">{{
                department.description | titlecase
              }}</mat-label>
            </div>
          </a>
        </div>
      </div>
    </ng-container>
  </div>
</main>
